import gsap from 'gsap'

import { getScrollTriggerOptions, opacityRevealAnimation } from './shared'
import { Animation } from '@/types'

export const opacityReveal = ({ nodeRef, reverse }: Animation) => {


  const timeline = gsap
    .timeline({
      ...getScrollTriggerOptions(nodeRef, reverse)
    })
    .add(opacityRevealAnimation(nodeRef), 0)

  return () => {
    timeline.kill()
  }
}
